import React, { JSX, ReactNode } from 'react';
import { usePageTitle } from '@ankr.com/raas-hooks';
import { useIsMDDown } from '@ankr.com/raas-themes';
import { Box } from '@mui/material';

import { PROJECT_TITLE } from '../../../common/const/values';
import { Header } from '../Header';
import { Sidebar } from '../Sidebar';
import { useLayoutDefaultStyles } from './useLayoutDefaultStyles';

interface ILayoutDefaultProps {
  children?: ReactNode;
  title?: string;
}

export function LayoutDefault({
  children,
  title,
}: ILayoutDefaultProps): JSX.Element {
  const { classes } = useLayoutDefaultStyles();

  const isBreakpointDown = useIsMDDown();

  usePageTitle({ projectName: PROJECT_TITLE, pageTitle: title });

  return (
    <Box className={classes.root}>
      <Header />
      <Box component="main" className={classes.main}>
        {!isBreakpointDown && (
          <Box className={classes.sidebarWrap}>
            <Sidebar />
          </Box>
        )}
        <Box className={classes.mainContent}>{children}</Box>
      </Box>
    </Box>
  );
}
